<template>
  <div id="img-content" class="rich_media_wrp">
    <h1 class="rich_media_title" id="activity-name">
      {{ $t('newsinfo.sugar_reduction.title') }}
    </h1>

    <div
      id="js_novel_card"
      class="novel-card js_wx_tap_highlight wx_tap_card"
      style="display: none"
    >
      <div class="arrow-jump-icon"></div>
    </div>

    <div
      class="rich_media_content js_underline_content autoTypeSetting24psection"
      id="js_content"
    >
      <section class="section-box">
        <section class="img-center-section">
          <section class="img-container" nodeleaf="">
           <img src="https://www.healthcode.com/media/news/newbrownlin_files/640.png" />
          </section>
        </section>

        <section class="img-center-section margin-top-10">
          <section class="img-container" nodeleaf="">
            <img :src="currentImageUrl" />
          </section>
        </section>

        <section class="flex-left">
          <section class="content-box bg-light-blue">
            <section class="divider-section">
              <section class="divider-line blue-line flex-end flex-100 margin-05em"></section>
              <section class="divider-dots">
                <section class="dot-container">
                  <section class="dot pink-dot"></section>
                </section>
                <section class="dot-container margin-bottom-4">
                  <section class="dot blue-dot"></section>
                </section>
                <section class="dot-container">
                  <section class="dot pink-dot"></section>
                </section>
              </section>
              <section class="divider-line blue-line flex-end flex-100 margin-05em"></section>
            </section>

            <section class="margin-top-10">
              <section class="text-justify line-height-18">
                <p class="normal-text">
                  <span>{{ $t('newsinfo.sugar_reduction.intro.paragraph1') }}</span>
                </p>
                <p class="normal-text">
                  <span><br /></span>
                </p>
                <p class="normal-text">
                  <span class="color-blue">
                    <strong>{{ $t('newsinfo.sugar_reduction.intro.paragraph2') }}</strong>
                  </span>
                </p>
              </section>
            </section>

            <section class="img-center-section margin-30-0">
              <section class="img-container" nodeleaf="">
                <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (1).png" />
              </section>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.intro.consensus') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.intro.overconsumption') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="container-center">
              <section class="gradient-bg">
                <section class="content-wrapper">
                  <section class="white-content-box">
                    <section class="text-justify">
                      <p class="normal-text">
                        <span><br /></span>
                      </p>
                    </section>
                    <section class="text-justify letter-spacing-2 color-light-blue line-height-18">
                      <p class="normal-text">
                        <span class="color-blue">
                          {{ $t('newsinfo.sugar_reduction.guidelineHighlight.warning') }}
                        </span>
                      </p>
                      <p class="normal-text">
                        <strong>
                          <span class="color-blue">
                            <span><br /></span>
                          </span>
                        </strong>
                      </p>
                      <p class="normal-text">
                        <span class="underline-blue">
                          <strong>
                            <span class="underline-blue color-blue">
                              {{ $t('newsinfo.sugar_reduction.guidelineHighlight.limit') }} {{ $t('newsinfo.sugar_reduction.guidelineHighlight.artificialSweeteners') }}
                            </span>
                          </strong>
                        </span>
                      </p>
                    </section>
                    <section class="text-justify">
                      <p class="normal-text">
                        <span><br /></span>
                      </p>
                    </section>
                  </section>
                </section>
              </section>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="img-center-section margin-30-0">
              <section class="img-container" nodeleaf="">
                <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (1).jpg" />
              </section>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.globalTrend.statement') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                <span class="color-blue font-size-18">
                  <em><strong>{{ $t('newsinfo.sugar_reduction.globalTrend.highlight1') }}</strong></em>
                </span>
              </p>
              <p class="normal-text">
                <span class="color-blue font-size-18">
                  <em><strong>{{ $t('newsinfo.sugar_reduction.globalTrend.highlight2') }}</strong></em>
                </span>
              </p>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="divider-section">
              <section class="divider-line blue-line flex-end flex-100 margin-05em"></section>
              <section class="divider-dots">
                <section class="dot-container">
                  <section class="dot pink-dot"></section>
                </section>
                <section class="dot-container margin-bottom-4">
                  <section class="dot blue-dot"></section>
                </section>
                <section class="dot-container">
                  <section class="dot pink-dot"></section>
                </section>
              </section>
              <section class="divider-line blue-line flex-end flex-100 margin-05em"></section>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.globalTrend.solution') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="flex-start">
              <section class="flex-middle width-auto">
                <section>
                  <section class="gradient-circle"></section>
                </section>
              </section>

              <section class="flex-middle width-auto">
                <section class="text-justify font-size-18">
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.technology.title') }}：</strong>
                    </span>
                  </p>
                  <p class="normal-text">
                    <strong>{{ $t('newsinfo.sugar_reduction.sections.technology.subtitle') }}</strong>
                  </p>
                </section>
              </section>
            </section>

            <section class="margin-bottom-10">
              <section class="gradient-line"></section>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                 <span v-html="$t('newsinfo.sugar_reduction.sections.technology.descriptionPart1')"></span>
               
                <span class="color-blue">
                  <em><strong>{{ $t('newsinfo.sugar_reduction.sections.technology.technologyName') }}</strong></em>
                </span>
                <span>{{ $t('newsinfo.sugar_reduction.sections.technology.descriptionPart2') }}</span>
              </p>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="img-center-section margin-30-0">
              <section class="img-container" nodeleaf="">
                <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (2).jpg" />
              </section>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.sections.technology.features.intro') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
              <ul class="disc-list">
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.technology.features.pureTaste.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.technology.features.pureTaste.description') }}</span>
                  </p>
                </li>
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.technology.features.zeroSugar.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.technology.features.zeroSugar.description') }}</span>
                  </p>
                </li>
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.technology.features.safety.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.technology.features.safety.description') }}</span>
                  </p>
                  <p class="normal-text">
                    <span><br /></span>
                  </p>
                </li>
              </ul>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="flex-start">
              <section class="flex-middle width-auto">
                <section>
                  <section class="gradient-circle"></section>
                </section>
              </section>

              <section class="flex-middle width-auto">
                <section class="text-justify font-size-18">
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.implementation.title') }}：</strong>
                    </span>
                  </p>
                  <p class="normal-text">
                    <strong>{{ $t('newsinfo.sugar_reduction.sections.implementation.subtitle') }}</strong>
                  </p>
                </section>
              </section>
            </section>

            <section class="margin-bottom-10">
              <section class="gradient-line"></section>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                 <span v-html="$t('newsinfo.sugar_reduction.sections.implementation.description')"></span>
                
                <span class="highlighted-text">
                  {{ $t('newsinfo.sugar_reduction.sections.implementation.productName') }}
                </span>
                <span>{{ $t('newsinfo.sugar_reduction.sections.implementation.descriptionEnd') }}</span>
              </p>
            </section>

            <section class="img-center-section margin-30-0">
              <section class="img-container" nodeleaf="">
                <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (2).png" />
              </section>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.intro') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
              <ul class="disc-list">
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.verification.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.verification.description') }}</span>
                  </p>
                </li>
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.healthBenefits.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.healthBenefits.description') }}</span>
                  </p>
                </li>
                <li>
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.design.title') }}</strong>
                    </span>
                    <span>{{ $t('newsinfo.sugar_reduction.sections.implementation.productFeatures.design.description') }}</span>
                  </p>
                  <p class="normal-text">
                    <span><br /></span>
                  </p>
                </li>
              </ul>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="flex-start">
              <section class="flex-middle width-auto">
                <section>
                  <section class="gradient-circle"></section>
                </section>
              </section>

              <section class="flex-middle width-auto">
                <section class="text-justify font-size-18">
                  <p class="normal-text">
                    <span class="color-blue">
                      <strong>{{ $t('newsinfo.sugar_reduction.sections.future.title') }}：</strong>
                    </span>
                  </p>
                  <p class="normal-text">
                    <strong>{{ $t('newsinfo.sugar_reduction.sections.future.subtitle') }}</strong>
                  </p>
                </section>
              </section>
            </section>

            <section class="margin-bottom-10">
              <section class="gradient-line"></section>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="text-justify line-height-18">
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                 <span v-html="$t('newsinfo.sugar_reduction.sections.future.potentialPart1')"></span>
               
                <strong><span class="color-blue">{{ $t('newsinfo.sugar_reduction.sections.future.potentialPart2') }}</span></strong>
                <span>{{ $t('newsinfo.sugar_reduction.sections.future.potentialPart3') }}</span>
              </p>
              <p class="normal-text">
                <span><br /></span>
              </p>
              <p class="normal-text">
                 <span v-html="$t('newsinfo.sugar_reduction.sections.future.prospectPart1') "></span>
                <span class="color-blue">
                  <strong>{{ $t('newsinfo.sugar_reduction.sections.future.prospectPart2') }}</strong>
                </span>
                <span>{{ $t('newsinfo.sugar_reduction.sections.future.prospectPart3') }}</span>
              </p>
            </section>

            <section class="text-justify">
              <p class="normal-text">
                <span><br /></span>
              </p>
            </section>

            <section class="img-center-section margin-top-10 margin-bottom-10">
              <section class="img-container" nodeleaf="">
                <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (3).jpg" />
              </section>
            </section>
          </section>
        </section>
      </section>

      <section class="img-center-section margin-top-10 margin-bottom-10">
        <section class="img-container" nodeleaf="">
          <img src="https://www.healthcode.com/media/news/newbrownlin_files/640 (4).jpg" />
        </section>
      </section>
    </div>
  </div>
</template>


<script setup>
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale, t } = useI18n();

const currentLang = computed(() => locale.value);
console.log('当前语言:', currentLang.value);
const currentImageUrl = computed(() => {
  const baseUrl = 'https://www.healthcode.com/media/news/newbrownlin_files/';
  const imageName = currentLang.value === 'zh' ? '640.jpg' : '640EN.png';
  return baseUrl + imageName;
});
const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem('locale', lang);
};

// 监听语言变化并执行相应操作
watch(locale, (newLocale) => {
  console.log(`语言已切换到: ${newLocale}`);
});

// 页面加载后执行的初始化操作
// 可以在这里添加图片懒加载、统计等逻辑
console.log('新闻页面加载完成');
</script>
<style scoped>
/* 基础样式重置 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* 容器类 */
.section-box {
  box-sizing: border-box;
  font-style: normal;
  font-weight: 400;
  text-align: justify;
  color: rgb(62, 62, 62);
  visibility: visible;
  margin-bottom: 0px;
}

/* 图片居中容器 */
.img-center-section {
  text-align: center;
  line-height: 0;
  box-sizing: border-box;
  visibility: visible;
}

.img-center-section.margin-top-10 {
  margin-top: 10px;
}

.img-center-section.margin-30-0 {
  margin: 30px 0px;
}

.img-center-section.margin-top-10.margin-bottom-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* 图片容器 */
.img-container {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  line-height: 0;
  width: 100%;
  box-sizing: border-box;
  visibility: visible;
}

/* 布局类 */
.flex-left {
  text-align: left;
  justify-content: flex-start;
  display: flex;
  flex-flow: row;
  margin: 0px 0px 10px;
  box-sizing: border-box;
}

.flex-center {
  text-align: center;
  justify-content: center;
  display: flex;
  flex-flow: row;
  margin: 0px;
  box-sizing: border-box;
}

.flex-start {
  justify-content: flex-start;
  display: flex;
  flex-flow: row;
  margin: 10px 0px 0px;
  box-sizing: border-box;
}

/* 内容框 */
.content-box {
  display: inline-block;
  width: 100%;
  vertical-align: top;
  align-self: flex-start;
  flex: 0 0 auto;
  box-sizing: border-box;
}

.content-box.bg-light-blue {
  background-color: rgb(228, 237, 249);
  padding: 27px 24px;
}

/* 宽度类 */
.width-auto {
  width: auto;
}

/* 对齐类 */
.flex-end {
  vertical-align: bottom;
  align-self: flex-end;
}

.flex-middle {
  vertical-align: middle;
  align-self: center;
}

.flex-100 {
  flex: 100 100 0%;
}

/* 间距类 */
.margin-05em {
  margin: 0.5em 0px;
}

.margin-top-10 {
  margin-top: 10px;
}

.margin-bottom-10 {
  margin-bottom: 10px;
}

.margin-bottom-4 {
  margin-bottom: 4px;
}

.margin-0 {
  margin: 0px;
}

/* 分隔线类 */
.divider-section {
  text-align: center;
  justify-content: center;
  display: flex;
  flex-flow: row;
  margin: 0px;
  box-sizing: border-box;
}

.divider-line {
  display: inline-block;
  vertical-align: bottom;
  width: auto;
  align-self: flex-end;
  flex: 100 100 0%;
  height: auto;
  box-sizing: border-box;
}

.divider-dots {
  display: inline-block;
  vertical-align: middle;
  width: auto;
  align-self: center;
  flex: 0 0 auto;
  min-width: 5%;
  max-width: 100%;
  height: auto;
  line-height: 0;
  padding: 4px;
  box-sizing: border-box;
  justify-content: center;
  display: flex;
  flex-flow: row;
  margin: 0px;
}

.dot-container {
  display: inline-block;
  vertical-align: bottom;
  width: 11px;
  flex: 0 0 auto;
  height: auto;
  margin: 0px;
  align-self: flex-end;
  box-sizing: border-box;
}

/* 线条类 */
.blue-line {
  background-color: rgb(35, 112, 210);
  height: 1px;
  box-sizing: border-box;
}

.gradient-line {
  background-image: linear-gradient(
    90deg,
    rgb(195, 239, 255) 13%,
    rgb(63, 192, 255) 50%,
    rgb(156, 232, 226) 89%
  );
  height: 1px;
  box-sizing: border-box;
}

/* 圆点类 */
.dot {
  display: inline-block;
  width: 5px;
  height: 5px;
  vertical-align: top;
  overflow: hidden;
  border-radius: 40px;
  box-sizing: border-box;
}

.pink-dot {
  background-color: rgb(247, 148, 187);
}

.blue-dot {
  background-color: rgb(35, 112, 210);
}

.gradient-circle {
  display: inline-block;
  width: 31px;
  height: 31px;
  vertical-align: top;
  overflow: hidden;
  background-image: linear-gradient(
    90deg,
    rgb(195, 244, 255) 13%,
    rgb(0, 138, 229) 50%,
    rgb(156, 213, 232) 89%
  );
  border-radius: 130px;
  box-sizing: border-box;
}

/* 文本类 */
.text-justify {
  text-align: justify;
  box-sizing: border-box;
}

.normal-text {
  white-space: normal;
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

.line-height-18 {
  line-height: 1.8;
}

.letter-spacing-2 {
  letter-spacing: 2px;
}

.font-size-18 {
  font-size: 18px;
}

/* 颜色类 */
.color-blue {
  color: rgb(35, 112, 210);
  box-sizing: border-box;
}

.color-light-blue {
  color: rgb(113, 152, 220);
}

.underline-blue {
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: rgb(35, 112, 210);
  text-decoration-thickness: 2px;
  color: rgb(35, 112, 210);
  box-sizing: border-box;
}

.highlighted-text {
  font-style: normal;
  font-size: 16px;
  justify-content: flex-start;
  flex-flow: row;
  vertical-align: top;
  align-self: flex-start;
  flex: 0 0 auto;
  background-color: rgb(228, 237, 249);
  text-align: justify;
  line-height: 1.8;
  color: rgb(35, 112, 210);
  font-weight: bold;
  box-sizing: border-box;
}

/* 列表类 */
.disc-list {
  list-style-type: disc;
  box-sizing: border-box;
  padding-left: 20px;
  list-style-position: outside;
}

/* 渐变背景容器 */
.container-center {
  text-align: center;
  justify-content: center;
  display: flex;
  flex-flow: row;
  margin: 15px 0px 10px;
  box-sizing: border-box;
}

.gradient-bg {
  display: inline-block;
  width: auto;
  vertical-align: top;
  align-self: flex-start;
  flex: 0 0 auto;
  background-image: linear-gradient(
    90deg,
    rgb(145, 254, 255) 0%,
    rgb(137, 166, 253) 100%
  );
  min-width: 5%;
  max-width: 100%;
  height: auto;
  margin: 0px 0px 0px 5px;
  box-sizing: border-box;
}

.content-wrapper {
  text-align: left;
  justify-content: flex-start;
  display: flex;
  flex-flow: row;
  margin: -5px 0px 5px;
  transform: translate3d(-5px, 0px, 0px);
  -webkit-transform: translate3d(-5px, 0px, 0px);
  -moz-transform: translate3d(-5px, 0px, 0px);
  -o-transform: translate3d(-5px, 0px, 0px);
  box-sizing: border-box;
}

.white-content-box {
  display: inline-block;
  width: 100%;
  vertical-align: top;
  align-self: flex-start;
  flex: 0 0 auto;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(113, 152, 220);
  background-color: rgb(255, 255, 255);
  padding: 5px 15px;
  box-sizing: border-box;
}

/* 图片样式 */
.rich_pages {
  vertical-align: middle;
  max-width: 100%;
  box-sizing: border-box;
  height: auto !important;
}

/* 原有样式保留 */
.rich_media_wrp {
  max-width: 677px;
  margin: 10rem auto 8rem auto;
  font-size: 16px;
  overflow: hidden;
}

.rich_media_title {
  font-size: 22px;
  line-height: 1.4;
  margin-bottom: 14px;
  font-weight: 700;
}

.not_in_mm .rich_media_meta_list {
  position: relative;
  z-index: 1;
}

.rich_media_meta_list {
  margin-bottom: 22px;
  line-height: 20px;
  font-size: 0;
  word-wrap: break-word;
}
.d2p-highlight {
  color: #2d8cf0;
  font-weight: bold;
}

.wx_tap_link {
  /* 原有样式 */
}

.js_wx_tap_highlight {
  /* 原有样式 */
}

.rich_media_meta {
  /* 原有样式 */
}

.icon_appmsg_tag {
  /* 原有样式 */
}

.appmsg_title_tag {
  /* 原有样式 */
}

.weui-wa-hotarea {
  /* 原有样式 */
}

.rich_media_meta_text {
  /* 原有样式 */
}

.rich_media_meta_nickname {
  /* 原有样式 */
}

.novel-card {
  /* 原有样式 */
  display: none;
}

.rich_media_content {
  text-size-adjust: var(--content-font-scale-percent, inherit);
}

.js_underline_content {
  /* 原有样式 */
}

.autoTypeSetting24psection {
  /* 原有样式 */
}
</style>